<template>
  <section class="content" style="padding-left: 0px;padding-right: 0px;">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <router-link to="/products-view"><p class="sg-top"><i class="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;{{this.$store.state.viewPDFName}}</p></router-link>
    </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <!-- <div class="sg-full-video"> -->
          <!-- <iframe style="width:100%;height:500px" src="https://online.fliphtml5.com/nqffk/qves/"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe> -->
          <iframe :src='catalogueUrl' width="100%" height="650" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%; height: 700px;" allowfullscreen> </iframe>
        <!-- </div> -->
        <p class="sg-pname">{{this.$store.state.viewPDFName}}</p>
        <p class="sg-disco">{{this.$store.state.viewPDFDescription}}</p>
    </div>
    </div>
    <br>
    <br>
  </section>
</template>
<script>
  export default {
    name: 'productCatalogue2',
    data: () => ({
      catalogueUrl: '',
      noContentErrorMsg: false
    }),
    created() {
      this.catalogueUrl = 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/' + this.$store.state.viewPDF
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// SingleProductPdf.vue?9c262340